/**
 * Character length constraints for each input tool type.
 * Used by frontend validation (selection-mode containers) and pre-save validation.
 *
 * These limits apply to the "Default Value" input (admin/editor side).
 * The signing flow should also read `maxLength` from the coordinate object.
 */
export const FIELD_CHAR_LIMITS = {
  Text: {
    minLength: 0,      // 0 = no minimum (unless isRequired)
    maxLength: 255,
  },
  Email: {
    minLength: 5,      // shortest valid email: a@b.co
    maxLength: 255,    // updated to 255 for consistency
  },
  Date: {
    minLength: 10,     // YYYY-MM-DD = 10 chars
    maxLength: 10,
  },
  PickList: {
    nameMaxLength: 50,    // picklist label / tool name
    optionMinLength: 1,   // each option label
    optionMaxLength: 50,  // each option label (updated from 100)
    maxOptions: 50,       // max number of dropdown options
  },
};

/**
 * Threshold (as a fraction of maxLength) at which the character counter
 * turns from green to red. e.g. 0.9 = red when ≥90% of limit used.
 */
export const CHAR_LIMIT_WARNING_THRESHOLD = 0.9;
